const API_FAILURE = 'api_error_failure';
const API_AUTH_ERROR = 'api_auth_error';

export default {
  API_FAILURE,
  API_AUTH_ERROR,
};

export const createAPIError = code => {
  const err = new Error(code);
  err.isAPIError = true;
  return err;
};

export const isAPIError = err => err.isAPIError;

export const defaultAPIError = (err, defaultError = API_FAILURE) => {
  throw isAPIError(err) ? err : createAPIError(defaultError);
};
